import React from 'react'
import classNames from 'classnames'
import { string, object, array, node, oneOfType } from 'prop-types'

const List = ({ children, className }) => (
  <ul className={classNames('sw-list', className)}>{children}</ul>
)

List.displayName = 'List'

List.propTypes = {
  /** Component's children */
  children: node,
  /** Custom className */
  className: oneOfType([string, object, array])
}

export default List
